import React, { Component } from 'react'
import { Motion, spring } from 'react-motion'
import PropTypes from 'prop-types'
import marked from 'marked'
import Swipeable from 'react-swipeable'

import arrow from '../img/arrow.svg'

const SLIDE_WIDTH = 86
const BORDER_WIDTH = (100 - SLIDE_WIDTH) / 2

export default class Carousel2 extends Component {
  constructor (props) {
    super(props)
    var newSlides = this.props.slides
    newSlides.unshift(this.props.slides[this.props.slides.length - 1])
    newSlides.push(this.props.slides[1])
    newSlides.push(this.props.slides[2])
    this.state = {
      index: 2,
      slides: newSlides,
      slidesLength: newSlides.length,
      immediate: false
    }
    this.instant = true
  }

  goLeft () {
    if (this.state.index === 0) {
      this.setState({index: this.state.slidesLength - 3}, () => {
        this.goLeft()
      })
    } else {
      this.setState({index: this.state.index - 1})
    }
  }

  goRight () {
    if (this.state.index === this.state.slidesLength - 3) {
      this.setState({index: 0}, () => {
        this.goRight()
      })
    } else {
      this.setState({index: this.state.index + 1})
    }
  }

  move (index) {
    if (this.state.slidesLength - 1 - (index + this.state.index) === 0) {
      this.goLeft()
    } else if (this.state.slidesLength - 1 - (index + this.state.index) === 2) {
      this.goRight()
    }
  }

  componentWillUpdate (nextProps, nextState) {
    if ((this.state.index === 0 && nextState.index === this.state.slidesLength - 3) ||
      (this.state.index === this.state.slidesLength - 3 && nextState.index === 0)) {
      this.instant = true
    } else {
      this.instant = false
    }
  }

  render () {
    let xTranslate = -(this.state.index + 1) * SLIDE_WIDTH + BORDER_WIDTH
    return <Swipeable onSwipedLeft={this.goRight.bind(this)} onSwipedRight={this.goLeft.bind(this)}>
             <img src={arrow} alt='pfeil-links' className={this.props.className + '-arrow ' + this.props.className + '-arrow--left'} />
             <Motion style={{x: this.instant ? xTranslate : spring(xTranslate)}}>
               {({x}) => <div className={this.props.className} style={{width: (this.state.slidesLength * SLIDE_WIDTH + 'vw'), transform: `translate(${x}vw, 0)`}}>
                            {this.state.slides.map((text, i) => {
                               //  var leftIndex = this.state.index !== 0 ? this.state.index - 1 : this.state.slidesLength - 1
                               //  var rightIndex = this.state.index !== this.state.slidesLength - 1 ? this.state.index + 1 : 0
                               let key = Object.keys(text)[0]
                               return <div
                                        className={(this.props.className + '-slide ' + this.props.className + '--' + key) + ((this.state.slidesLength - 1 - (i + this.state.index) === 0) || (this.state.slidesLength - 1 - (i + this.state.index) === 2) ? (' ' + this.props.className +  '--pointer') : '')}
                                        key={key + i}
                                        style={{width: (SLIDE_WIDTH + 'vw')}}
                                        onClick={this.move.bind(this, i)}>
                                        <div className={this.props.className + '-slide-text'} dangerouslySetInnerHTML={{__html: marked(text[key].text).replace(/\n/gi, '<br />')}} />
                                        <div className={this.props.className + '-slide-name'}>
                                          {text[key].name}
                                        </div>
                                      </div>
                             })}
                          </div>}
             </Motion>
             <img src={arrow} alt='pfeil-rechts' className={this.props.className + '-arrow ' + this.props.className + '-arrow--right'} />
           </Swipeable>
  }
}

Carousel2.propTypes = {
  slides: PropTypes.array.isRequired,
  interval: PropTypes.number,
  className: PropTypes.string.isRequired
}



/** WEBPACK FOOTER **
 ** ./src/components/carousel2.js
 **/